// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"12f1cb40","160":"e61ce5c4","208":"c9afa32c","293":"ad048b99","516":"b09c606f","519":"e40fac90","917":"0c906ab7","946":"b07398a5"}[chunkId] + ".chunk.js";
};